type TLink = string;

const MESSAGES = {
  pro: 'This module is available on the Professional plan.',
  premium: 'This module is available on Professional plan.',
  unauthorized: 'You have to Log In and Upgrade Plan to the Professional plan to see this module.',
};

const getDescription = (description: string, url?: TLink) => (
  <>
    { description }
    { url && (
      <>
        &nbsp;
        <a href={ url } data-test="learnMoreLink">Learn more</a>
      </>
    ) }
  </>
);

export const getProDescription = (url?: TLink) => getDescription(MESSAGES.pro, url);
export const getPremiumDescription = (url?: TLink) => getDescription(MESSAGES.premium, url);
export const getUnauthorizedDescription = (url?: TLink) => getDescription(MESSAGES.unauthorized, url);
